import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './logpmf.js';
import __var_2__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Natural logarithm of the probability mass function (PMF) for a binomial distribution.
*
* @module @stdlib/stats/base/dists/binomial/logpmf
*
* @example
* var logpmf = require( '@stdlib/stats/base/dists/binomial/logpmf' );
*
* var y = logpmf( 3.0, 20, 0.2 );
* // returns ~-1.583
*
* y = logpmf( 21.0, 20, 0.2 );
* // returns -Infinity
*
* y = logpmf( 5.0, 10, 0.4 );
* // returns ~-1.606
*
* y = logpmf( 0.0, 10, 0.4 );
* // returns ~-5.108
*
* @example
* var factory = require( '@stdlib/stats/base/dists/binomial/logpmf' ).factory;
*
* var logpmf = factory( 10, 0.5 );
*
* var y = logpmf( 3.0 );
* // returns ~-2.146
*
* y = logpmf( 5.0 );
* // returns ~-1.402
*/

// MODULES //
var setReadOnly = __var_0__;
var logpmf = __var_1__;
var factory = __var_2__;


// MAIN //

setReadOnly( logpmf, 'factory', factory );


// EXPORTS //
export default logpmf;
